import React from "react";
import MainSection from "../components/mainSection";
import HowItWorks from "../components/howIt";

import FAQs from "../components/faqs";
import VideoPlayer from "../components/videoPlayer";
import FeaturedTrendyProducts from "../components/trendyProducts";
import Office from "../assets/img/office.jpg";
import adinVideo from "../assets/videos/adin.mp4";

import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Certifications from "../components/certificates";
import FactoryImages from "../components/factory";

const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

function AnimatedSection({ children }: { children: React.ReactNode }) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.15 });
  return (
    <motion.div
      ref={ref}
      variants={fadeInUp}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
    >
      {children}
    </motion.div>
  );
}

function Home() {
  return (
    <div className="">
      <MainSection />

      <AnimatedSection>
        <div className="bg-[#322e88] p-8 w-full h-full mb-10 lg:px-32 md:px-6 sm:px-4 bg-opacity-10">
          <h2 className="lg:text-5xl font-extrabold text-center mb-0 mt-12 text-4xl lg:ml-64">
            Welcome to <span className="text-[#f98715]">Adins</span>{" "}
            International
          </h2>
          <div className="flex flex-col md:flex-row items-center justify-center space-y-6 md:space-y-0 md:space-x-14 py-1">
            <div className="w-64 h-64 md:w-80 md:h-80 bg-white rounded-full shadow-lg overflow-hidden lg:mt-0 mt-6">
              <img
                src={Office}
                alt="Company Logo"
                className="w-full h-full object-cover"
              />
            </div>
            <p className="text-gray-700 text-sm lg:text-lg leading-relaxed w-full md:w-2/3 px-2 text-justify md:text-left sm:text-left lg:mt-14">
              At <strong> Adins International Pvt. Ltd.</strong>, we blend the
              wisdom of Ayurveda with modern science to create high-quality,
              vegetarian-friendly pet supplements that are safe, effective, and
              cruelty-free. Our product line includes probiotic powders, calming
              chews, omega-3 soft gels, and herbal blends—all designed to
              naturally support your pet’s immunity, digestion, skin, joints,
              and emotional well-being. Every formula is vet-approved and made
              with love, using 100% plant-based ingredients—free from chemicals,
              artificial additives, and animal testing. We’re more than a pet
              wellness brand—we’re a movement. A movement toward conscious,
              compassionate care that honors both pets and the planet. Whether
              you're a pet parent, retailer, or brand partner, Adins is here to
              help you deliver trusted, sustainable solutions for pet
              health—because pets deserve nothing less than the best, naturally.
            </p>
          </div>
        </div>
      </AnimatedSection>

      <AnimatedSection>
        <HowItWorks />
      </AnimatedSection>

      <AnimatedSection>
        <VideoPlayer videoSrc={adinVideo} backgroundClass="bg-[#f98715] h-10" />
      </AnimatedSection>

      <AnimatedSection>
        <FeaturedTrendyProducts />
      </AnimatedSection>

       <AnimatedSection>
        <Certifications />
      </AnimatedSection>

      <AnimatedSection>
        <FactoryImages />
      </AnimatedSection>

      <AnimatedSection>
        <FAQs />
      </AnimatedSection>
    </div>
  );
}

export default Home;
